module.exports = __webpack_public_path__ + "static/media/Immobilier-Direction-de-Travaux-Vaux.b8e94d1a.jpg";